import { NgModule } from '@angular/core';
import { RouterModule,Routes } from '@angular/router';
import { PrenavbarComponent } from './prelogin/prenavbar/prenavbar.component';
import { AuthGuardService } from './services/auth-guard/auth-guard-service';
import { MSALAuthGuardService } from './services/auth-guard/msalauth-Guard-service';
import { PreauthGuard } from './services/auth-guard/preauth.guard';
import { KsaAdminGuard } from './services/ksa/ksa-auth-guard/ksaAdmin.guard';
const routes: Routes = [
  {
     path: 'home',
     loadChildren: () =>
       import('./postlogin/postlogin.module').then((m) => m.PostloginModule),
      canActivate: [MSALAuthGuardService,AuthGuardService,KsaAdminGuard]
  },
  {
    path: 'prelogin',
    canActivate: [MSALAuthGuardService, PreauthGuard],
    component: PrenavbarComponent,
  },
  
   
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
